const isEmpty = (value) => (!value || value.trim() === '');
  
const validateTitle = (value) => {
    if (isEmpty(value)) {
        return 'Insira o nome do estabelecimento.';
    }
}

const validatePhone = (value) => {
    if (value) {
        const phone = value.replace(/[^\d]/g, '');
        const MOBILE_PHONE_LENGTH = 11;
        const LANDLINE_PHONE_LENGTH = 10;
        const length = phone.length;
        if (length < LANDLINE_PHONE_LENGTH || length > MOBILE_PHONE_LENGTH ) {
            return 'Informe todos os números incluíndo o DDD.';
        }
    }
}

const validateAddress = (address) => {
    if (typeof address === 'undefined') {
        return {
            zipCode: 'Insira o CEP.'
        };
    }
    let errors = {};
    if (isEmpty(address.zipCode)) {
        errors.address = 'Insira o CEP.';
    }
    if (isEmpty(address.address)) {
        errors.address = 'Insira o logradouro.';
    }
    if (isEmpty(address.neighborhood)) {
        errors.neighborhood = 'Insira o bairro.';
    }
    if (isEmpty(address.city)) {
        errors.city = 'Insira a cidade.';
    }
    if (isEmpty(address.state)) {
        errors.state = 'Selecione a UF.';
    }
    if (isEmpty(address.number)) {
        errors.number = 'Insira o número.';
    }
    return errors;
}

const validations = values => ({
    title: validateTitle(values.title),
    phone: validatePhone(values.phone),
    address: validateAddress(values.address)
});

export default validations;


// WEBPACK FOOTER //
// ./src/components/Pages/Establishments/Management/validations.js